import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {GlobalService} from '../services/global.service';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';
import {Md5} from 'ts-md5';
import {StorageHandler} from './storage-handler';
import {AuthService} from 'src/app/auth/services/auth.service';
// import {ParallelHasher} from 'ts-md5';
import {AlertHandler} from './alert-handler';

@Injectable()
export class InterceptorHandler implements HttpInterceptor {

  constructor(private globalService: GlobalService,
              private router: Router,
              private authService: AuthService,
              private storageHandler: StorageHandler) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.globalService.token;
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `${token}`
        }
      });
    }

    if (request.body && (request.body.isFormData)) {
      delete request.body.isFormData;

      if (request.body.file) {
        request['body']['checksum'] = getFileChecksome(request.body.file);
      } else if (request.body.attachment) {
        request['body']['checksum'] = getFileChecksome(request.body.attachment);
      }

      const formData = new FormData();
      for (const i in request.body) {
        formData.append(i, request.body[i]);
      }
      request = request.clone({body: formData});

    } else {
      if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
        request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
      }
    }


    return next.handle(request).pipe(catchError(
      (err: HttpErrorResponse) => {
        console.log(err);
        if (err.status === 401 && this.globalService.expiredCounter === 0) {
          this.globalService.expiredCounter = this.globalService.expiredCounter + 1;
          AlertHandler.ErrorAlert(err.error.message + ' :Please Login Again', 5000);
          if (environment.ssoEnabled) {
            if (this.storageHandler.getLocalStorage('SSO_URL')) {
              const ssoUrl = this.storageHandler.getLocalStorage('SSO_URL');
              this.globalService.deleteUserSession();
              window.location.replace(ssoUrl);
            }
          } else if (environment.msalEnabled) {
            this.globalService.deleteUserSession();
            this.router.navigate(['auth/msl-login']);
          } else if (environment.enabledBaseHref) {
            this.globalService.deleteUserSession();
            window.location.replace(window.location.origin);
          } else {
            this.globalService.deleteUserSession();
            this.router.navigate(['auth/login']);
          }
        }
        return throwError(() => err);
      }
    ));
  }
}

function getFileChecksome(file) {
  const checksum = Md5.hashStr(file);
  return checksum;
}
